import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

// 3rd parties
import { TranslateService } from "@ngx-translate/core";
import { SDPTranslationStorage } from "./translation-storage";


@Injectable({
  providedIn: 'root',
})
export class SabisTranslateService {
  public onLangChange: Subject<string> = new Subject();
  private _languageRequest: Observable<boolean> | null = null;

  constructor(private _translateService: TranslateService, private _translationStorage: SDPTranslationStorage) {
    this._translateService.onLangChange.subscribe(l => {
      this.onLangChange.next(l.lang);
    });
  }

  //public loadDefaultLanguage(): Observable<boolean> {
  //  //let url = this._langUrl + "/applicationlanguage";
  //  //if (!this._languageRequest) {
  //  //  this._languageRequest = this._httpClient.get<{ lang: string }>(url).pipe(switchMap(result => {
  //  //    return this.loadLanguage(result.lang);
  //  //  }));
  //  //}
  //  return this._languageRequest!;
  //}

  public loadCachedLanguage(): Observable<boolean> {
    let cached = this._translationStorage.getItem('lang');
    if (cached) {
      return this.use(cached);
    } else {
      // Load defaultLanguage (english)
      return this.loadLanguage("en-US");
    }
  }

  /**
   * Set the current language of the application
   * @param lang language code to use ex: en-US
   */
  public loadLanguage(lang: string): Observable<boolean> {
    this._translationStorage.setItem('lang', lang);
    this.setDefaultLang(lang);
    return this.use(lang);
  }

  /**
   * Get all languages supported by the app
   */
  public getSupportedLanguages(): Language[] {
    return [
      { name: "English", code: "en-US" },
      { name: "Français", code: "fr-FR" },
      { name: "Portuguese", code: "pt-PT" },
    ];
  }

  /**
   * Sets the default language to use as a fallback
   * @param lang
   */
  setDefaultLang(code: string) {
    this._translateService.setFallbackLang(code);
  }

  /**
   * Changes the lang currently used
   * @key lang
   * @returns {Observable<*>}
   */
  use(code: string): Observable<any> {
    return this._translateService.use(code);
  }

  /**
   * Returns a translation instantly from the internal state of loaded translation.
   * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
   * @param key
   * @param interpolateParams
   * @returns {string}
   */
  public instant(key: string | Array<string>, interpolateParams?: Object): string | any {
    return this._translateService.instant(key, interpolateParams);
  }
}

export interface Language {
  code: string;
  name: string;
}

